import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { UPDATE_PARENT_PROJECT, UPDATE_PARENT_PROJECT_SUCCESS, UPDATE_PARENT_PROJECT_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateParentProject({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/global-bins`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Bins updated successfully`);
      yield put({
        type: UPDATE_PARENT_PROJECT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: UPDATE_PARENT_PROJECT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_PARENT_PROJECT_ERROR, payload: error });
  }
}

export function* watchUpdateParentProject() {
  yield takeEvery(UPDATE_PARENT_PROJECT, updateParentProject);
}

function* updateParentProjectSaga() {
  yield all([fork(watchUpdateParentProject)]);
}

export default updateParentProjectSaga;
